/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type calendarSpaceCalendar_calendar$ref: FragmentReference;
declare export opaque type calendarSpaceCalendar_calendar$fragmentType: calendarSpaceCalendar_calendar$ref;
export type calendarSpaceCalendar_calendar = $ReadOnlyArray<{|
  +day: ?string,
  +checkin: ?string,
  +checkout: ?string,
  +checkinMorning: ?string,
  +checkoutMorning: ?string,
  +checkinAfternoon: ?string,
  +checkoutAfternoon: ?string,
  +checkinNight: ?string,
  +checkoutNight: ?string,
  +$refType: calendarSpaceCalendar_calendar$ref,
|}>;
export type calendarSpaceCalendar_calendar$data = calendarSpaceCalendar_calendar;
export type calendarSpaceCalendar_calendar$key = $ReadOnlyArray<{
  +$data?: calendarSpaceCalendar_calendar$data,
  +$fragmentRefs: calendarSpaceCalendar_calendar$ref,
  ...
}>;
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "calendarSpaceCalendar_calendar",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "day",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "checkin",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "checkout",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "checkinMorning",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "checkoutMorning",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "checkinAfternoon",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "checkoutAfternoon",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "checkinNight",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "checkoutNight",
      "storageKey": null
    }
  ],
  "type": "CalendarByDay",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '1d7672e63c6ecb4f735ec4b435b0cf7f';

module.exports = node;
